import React, { useState, useEffect } from 'react'
import './index.css'
import { PlanPosition, PlanPositionStage } from '../../types'
import { Structure } from '../../../../Org/Structure/types'

import { CurrencyList } from '../../Edit/types'

import HoverTooltip from '../../../../../../components/HoverTooltip'

type Props = {
    keyindex: number
    stage: string
    planPosition: PlanPosition
    structData: Structure[]
    selected: boolean
    onClick: (pos_guid: string) => void
    onDoubleClick: (pos_guid: string) => void
    onRightClick: (guid: string) => void
    theme: string
    currency: CurrencyList[]
}

const POSITION_STATUS = new Map([
    ['P', 'Размещена'],
    ['A', 'Аннулирована'],
    ['N', 'Новая'],
    ['C', 'Изменение'],
])

const POSITION_DRAFT_STATUS = new Map([
    ['P', 'Размещение'],
    ['A', 'Аннулирование позиции'],
    ['N', 'Новая позиция'],
    ['C', 'Изменение позиции'],
])

const MONTHS = [
    'январь',
    'февраль',
    'март',
    'апрель',
    'май',
    'июнь',
    'июль',
    'август',
    'сентябрь',
    'октябрь',
    'ноябрь',
    'декабрь',
]

const GWS = new Map([
    ['G', 'Товар'],
    ['W', 'Работа'],
    ['S', 'Услуга'],
])

const PlanPositionsTableRow: React.FC<Props> = ({
    keyindex,
    stage,
    planPosition,
    structData,
    selected,
    onClick,
    onDoubleClick,
    onRightClick,
    theme,
    currency,
}) => {
    const getNameStruct = (struct_guid: string) => {
        const nameSctruct = structData.find((s) => s.guid === struct_guid)
        return nameSctruct?.struct_short_name || '-'
    }

    const updatedDate = new Date(planPosition.sys_updated_at)
    updatedDate.setHours(updatedDate.getHours())

    const formattedUpdateDate = updatedDate
        .toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        })
        .replace(/\//g, '.')
    const formattedUpdateTime = updatedDate.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    })

    const createdDate = new Date(planPosition.sys_created_at)
    createdDate.setHours(createdDate.getHours())

    const formattedCreatedDate = createdDate
        .toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        })
        .replace(/\//g, '.')
    const formattedCreatedTime = createdDate.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    })

    const STATUS_COLOR =
        theme == 'dark'
            ? new Map([
                  ['Черновик', '#4E9AFF'],
                  ['Готово', '#049664'],
                  ['Подготовка', '#3C69FE'],
                  ['Готово к отправке', '#2235FF'],
                  ['Отправлено в ЕИС', '#049664'],
                  ['Размещена', '#1114CB'],
                  ['Аннулирована', '#333033'],
              ])
            : new Map([
                  ['Черновик', '#D6EFFF'],
                  ['Готово', '#83D2B7'],
                  ['Подготовка', '#C7E4FE'],
                  ['Готово к отправке', '#ABD7FE'],
                  ['Отправлено в ЕИС', '#83D2B7'],
                  ['Размещена', '#90C0FF'],
                  ['Аннулирована', '#F6FBFF'],
              ])

    const STAGE_COLOR =
        theme == 'dark'
            ? new Map([
                  ['Редактирование', '#3C69FE'],
                  ['Подготовка к размещению', '#2235FF'],
                  ['Отправка в ЕИС', '#1114CB'],
                  ['План закупки в ЕИС', '#231D73'],
              ])
            : new Map([
                  ['Редактирование', '#C7E4FE'],
                  ['Подготовка к размещению', '#ABD7FE'],
                  ['Отправка в ЕИС', '#90C0FF'],
                  ['План закупки в ЕИС', '#A0BBF4'],
              ])

    const POSITION_STATUS_COLOR =
        theme == 'dark'
            ? new Map([
                  ['N', '#3C69FE'],
                  ['C', '#563AF5'],
                  ['A', '#3A3A3C'],
                  ['P', '#1114CB'],
              ])
            : new Map([
                  ['N', '#C7E4FE'],
                  ['C', '#ABD7FE'],
                  ['A', '#EBEDF0'],
                  ['P', '#90C0FF'],
              ])

    const POSITION_DRAFT_STATUS_COLOR =
        theme == 'dark'
            ? new Map([
                  ['N', '#8E8E93'],
                  ['C', '#636366'],
                  ['A', '#3A3A3C'],
                  ['P', '#90C0FF'],
              ])
            : new Map([
                  ['N', '#E4E8F0'],
                  ['C', '#CFD6E2'],
                  ['A', '#B7BECA'],
                  ['P', '#90C0FF'],
              ])

    return (
        <>
            {stage != 'План закупки в ЕИС' ? (
                <div
                    className={
                        selected
                            ? 'plan-position-table-row-selected'
                            : 'plan-position-table-row'
                    }
                    onDoubleClick={() => onDoubleClick(planPosition.guid)}
                    onClick={() => onClick(planPosition.guid)}
                    onContextMenu={(e) => {
                        e.preventDefault() // Отключает стандартное контекстное меню
                        onRightClick(planPosition.guid)
                    }}
                >
                    <div className="flex h-[70px] w-8 items-center justify-center text-center">
                        <input
                            type="checkbox"
                            checked={selected}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => {
                                onClick(planPosition.guid)
                            }}
                        />
                    </div>
                    <div className="flex h-[70px] w-12 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                        {keyindex}
                    </div>
                    <HoverTooltip
                        tooltipText={
                            planPosition.approval_status == 0
                                ? 'Идет согласование'
                                : planPosition.approval_status == 1 ||
                                    planPosition.approval_status == 2
                                  ? 'Согласовано'
                                  : planPosition.approval_status == 3
                                    ? 'Не согласовано'
                                    : planPosition.approval_status == 4
                                      ? 'Отменено'
                                      : planPosition.approval_status == null
                                        ? 'Отсутствует'
                                        : ''
                        }
                    >
                        <div className="flex h-[70px] w-10 items-center justify-center">
                            <div
                                className={`flex flex-row w-4 h-4  rounded-full 
                                ${
                                    theme == 'dark'
                                        ? planPosition.approval_status == 0
                                            ? 'bg-[#FAB502]'
                                            : planPosition.approval_status ==
                                                    1 ||
                                                planPosition.approval_status ==
                                                    2
                                              ? 'bg-[#049664]'
                                              : planPosition.approval_status ==
                                                  3
                                                ? 'bg-[#C15C5C]'
                                                : planPosition.approval_status ==
                                                    4
                                                  ? 'bg-[#464447]'
                                                  : planPosition.approval_status ==
                                                      null
                                                    ? 'bg-[#464447]'
                                                    : ''
                                        : planPosition.approval_status == 0
                                          ? 'bg-[#FAB502]'
                                          : planPosition.approval_status == 1 ||
                                              planPosition.approval_status == 2
                                            ? 'bg-[#83d2b7]'
                                            : planPosition.approval_status == 3
                                              ? 'bg-[#ed9cae]'
                                              : planPosition.approval_status ==
                                                  4
                                                ? 'bg-[#d0d0d0]'
                                                : planPosition.approval_status ==
                                                    null
                                                  ? 'bg-[#d0d0d0]'
                                                  : ''
                                }
                                `}
                            ></div>
                        </div>
                    </HoverTooltip>
                    <div className="flex h-[70px] w-12 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                        {planPosition.ordinal_number}
                    </div>
                    <div
                        className={`flex h-[70px] w-24 p-1 items-center justify-center text-center rounded`}
                        style={{
                            backgroundColor: planPosition.position_stage
                                ? STAGE_COLOR.get(planPosition.position_stage)
                                : 'transparent',
                        }}
                    >
                        {planPosition.position_stage}
                    </div>
                    <div
                        className="flex h-[70px] w-24 p-1 items-center justify-center text-center rounded"
                        style={{
                            backgroundColor: planPosition.position_status
                                ? STATUS_COLOR.get(planPosition.position_status)
                                : 'transparent',
                        }}
                    >
                        {planPosition.position_status}
                    </div>

                    <div className="flex h-[70px] flex-1 items-center justify-start text-left min-w-44 px-2 ">
                        <HoverTooltip
                            tooltipText={planPosition.contract_subject}
                        >
                            <p className="fourrow">
                                {planPosition.contract_subject
                                    ? planPosition.contract_subject
                                    : '-'}
                            </p>
                        </HoverTooltip>
                    </div>

                    <div className="flex h-[70px] w-28 items-center justify-end text-right px-2 gap-1">
                        <HoverTooltip
                            tooltipText={
                                planPosition.currency_digital_code
                                    ? String(
                                          currency.find(
                                              (c) =>
                                                  c.num_code ===
                                                  String(
                                                      planPosition.currency_digital_code
                                                  )
                                          )?.name
                                      )
                                    : '-'
                            }
                        >
                            <span>
                                {Number(
                                    planPosition.maximum_contract_price
                                ).toLocaleString('ru-RU', {
                                    minimumFractionDigits: 2,
                                })}{' '}
                                {planPosition.currency_digital_code
                                    ? planPosition.currency_digital_code == 643
                                        ? ''
                                        : currency.find(
                                              (c) =>
                                                  c.num_code ===
                                                  String(
                                                      planPosition.currency_digital_code
                                                  )
                                          )?.char_sign || '?'
                                    : ''}
                            </span>
                        </HoverTooltip>
                    </div>

                    <div className="flex h-[70px] w-28 items-center justify-end text-right px-2 ">
                        {planPosition.purchase_planned_date === null ? (
                            planPosition.purchase_period_month ? (
                                <>
                                    {MONTHS[
                                        Number(
                                            planPosition.purchase_period_month
                                        ) - 1
                                    ] + ' '}
                                    {planPosition.purchase_period_year}
                                </>
                            ) : (
                                '-'
                            )
                        ) : (
                            planPosition.purchase_planned_date
                                ?.split('-')
                                .reverse()
                                .join('-')
                                .replace(/[\-]/g, '.')
                        )}
                    </div>
                    <div className="flex h-[70px] w-28 items-center justify-end text-right px-2 ">
                        {planPosition.contract_end_date ? (
                            <>
                                {MONTHS[
                                    Number(
                                        planPosition.contract_end_date?.slice(
                                            5,
                                            7
                                        )
                                    ) - 1
                                ] + ' '}
                                {planPosition.contract_end_date?.slice(0, 4)}
                            </>
                        ) : (
                            '-'
                        )}
                    </div>
                    <div className="flex h-[70px] w-44 items-center justify-center text-center">
                        <p className="fourrow">
                            {planPosition.purchase_method_name
                                ? planPosition.purchase_method_name
                                : '-'}
                        </p>
                    </div>
                    <div
                        className={
                            'flex h-[70px] w-24 items-center justify-center text-center rounded'
                        }
                        style={{
                            backgroundColor: planPosition.status
                                ? POSITION_DRAFT_STATUS_COLOR.get(
                                      planPosition.status
                                  )
                                : 'transparent',
                        }}
                    >
                        {POSITION_DRAFT_STATUS.get(String(planPosition.status))}
                    </div>
                    <div className="flex h-[70px] w-24 items-center justify-center text-center">
                        {planPosition.type_object_purchase_position
                            ? GWS.get(
                                  String(
                                      planPosition.type_object_purchase_position
                                  )
                              )
                            : '-'}
                    </div>
                    <HoverTooltip
                        tooltipText={`${planPosition.struct_name ? planPosition.struct_name : 'Отсутствует'}`}
                        align="center"
                    >
                        <div className="flex h-[70px] w-24 items-center justify-center text-center">
                            {planPosition.struct_guid !== undefined &&
                            planPosition.struct_guid !== null &&
                            planPosition.struct_guid !== ''
                                ? getNameStruct(planPosition.struct_guid)
                                : '-'}
                        </div>
                    </HoverTooltip>
                    <div className="flex h-[70px] w-20 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                        {planPosition.position_version}
                    </div>
                    <div className="flex h-[70px] w-20 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                        {formattedUpdateDate}
                        <br />
                        {formattedUpdateTime}
                    </div>
                    <div className="flex h-[70px] w-14 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                        <HoverTooltip
                            tooltipText={
                                planPosition.first_name !== null
                                    ? planPosition.last_name +
                                      ' ' +
                                      planPosition.first_name
                                    : 'Отсутствует'
                            }
                            align="left"
                        >
                            <div className="flex h-8 w-8 rounded-full items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#d9dce0] dark:bg-[#333033]">
                                {planPosition.first_name !== null
                                    ? planPosition.last_name?.charAt(0) +
                                      planPosition.first_name?.charAt(0)
                                    : 'О'}
                            </div>
                        </HoverTooltip>
                    </div>
                </div>
            ) : (
                <div
                    className={
                        selected
                            ? 'plan-position-table-row-selected'
                            : 'plan-position-table-row'
                    }
                    onDoubleClick={() => onDoubleClick(planPosition.guid)}
                    onClick={() => onClick(planPosition.guid)}
                    onContextMenu={(e) => {
                        e.preventDefault() // Отключает стандартное контекстное меню
                        onRightClick(planPosition.guid)
                    }}
                >
                    <div className="flex h-[70px] w-8 items-center justify-center text-center">
                        <input
                            type="checkbox"
                            checked={selected}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => {
                                onClick(planPosition.guid)
                            }}
                        />
                    </div>
                    <div className="flex h-[70px] w-12 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                        {keyindex}
                    </div>
                    <HoverTooltip
                        tooltipText={
                            planPosition.approval_status == 0
                                ? 'Идет согласование'
                                : planPosition.approval_status == 1 ||
                                    planPosition.approval_status == 2
                                  ? 'Согласовано'
                                  : planPosition.approval_status == 3
                                    ? 'Не согласовано'
                                    : planPosition.approval_status == 4
                                      ? 'Отменено'
                                      : planPosition.approval_status == null
                                        ? 'Отсутствует'
                                        : ''
                        }
                    >
                        <div className="flex h-[70px] w-10 items-center justify-center">
                            <div
                                className={`flex flex-row w-4 h-4  rounded-full 
                                ${
                                    theme == 'dark'
                                        ? planPosition.approval_status == 0
                                            ? 'bg-[#FAB502]'
                                            : planPosition.approval_status ==
                                                    1 ||
                                                planPosition.approval_status ==
                                                    2
                                              ? 'bg-[#049664]'
                                              : planPosition.approval_status ==
                                                  3
                                                ? 'bg-[#C15C5C]'
                                                : planPosition.approval_status ==
                                                    4
                                                  ? 'bg-[#464447]'
                                                  : planPosition.approval_status ==
                                                      null
                                                    ? 'bg-[#464447]'
                                                    : ''
                                        : planPosition.approval_status == 0
                                          ? 'bg-[#FAB502]'
                                          : planPosition.approval_status == 1 ||
                                              planPosition.approval_status == 2
                                            ? 'bg-[#83d2b7]'
                                            : planPosition.approval_status == 3
                                              ? 'bg-[#ed9cae]'
                                              : planPosition.approval_status ==
                                                  4
                                                ? 'bg-[#d0d0d0]'
                                                : planPosition.approval_status ==
                                                    null
                                                  ? 'bg-[#d0d0d0]'
                                                  : ''
                                }
                                `}
                            ></div>
                        </div>
                    </HoverTooltip>
                    <div className="flex h-[70px] w-12 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                        {planPosition.ordinal_number}
                    </div>
                    <div
                        className={`flex h-[70px] w-24 items-center justify-center text-center rounded`}
                        style={{
                            backgroundColor: planPosition.position_stage
                                ? STAGE_COLOR.get(planPosition.position_stage)
                                : 'transparent',
                        }}
                    >
                        {planPosition.position_stage}
                    </div>
                    <div
                        className="flex h-[70px] w-24 items-center justify-center text-center rounded"
                        style={{
                            backgroundColor: planPosition.position_status
                                ? POSITION_STATUS_COLOR.get(planPosition.status)
                                : 'transparent',
                        }}
                    >
                        {POSITION_STATUS.get(String(planPosition.status))}
                    </div>
                    <div className="flex h-[70px] flex-1 items-center justify-start text-left min-w-44 px-2 ">
                        <HoverTooltip
                            tooltipText={`${planPosition.contract_subject ? planPosition.contract_subject : 'Отсутствует'}`}
                        >
                            <p className="fourrow">
                                {planPosition.contract_subject
                                    ? planPosition.contract_subject
                                    : '-'}
                            </p>
                        </HoverTooltip>
                    </div>
                    <div className="flex h-[70px] w-28 items-center justify-end text-right px-2 gap-1">
                        <HoverTooltip
                            tooltipText={
                                planPosition.currency_digital_code
                                    ? String(
                                          currency.find(
                                              (c) =>
                                                  c.num_code ===
                                                  String(
                                                      planPosition.currency_digital_code
                                                  )
                                          )?.name
                                      )
                                    : '-'
                            }
                        >
                            <span>
                                {Number(
                                    planPosition.maximum_contract_price
                                ).toLocaleString('ru-RU', {
                                    minimumFractionDigits: 2,
                                })}{' '}
                                {planPosition.currency_digital_code
                                    ? planPosition.currency_digital_code == 643
                                        ? ''
                                        : currency.find(
                                              (c) =>
                                                  c.num_code ===
                                                  String(
                                                      planPosition.currency_digital_code
                                                  )
                                          )?.char_sign || '?'
                                    : ''}
                            </span>
                        </HoverTooltip>
                    </div>
                    <div className="flex h-[70px] w-28 items-center justify-end text-right px-2 ">
                        {planPosition.purchase_planned_date === null ? (
                            planPosition.purchase_period_month ? (
                                <>
                                    {MONTHS[
                                        Number(
                                            planPosition.purchase_period_month
                                        ) - 1
                                    ] + ' '}
                                    {planPosition.purchase_period_year}
                                </>
                            ) : (
                                '-'
                            )
                        ) : (
                            planPosition.purchase_planned_date
                                ?.split('-')
                                .reverse()
                                .join('-')
                                .replace(/[\-]/g, '.')
                        )}
                    </div>
                    <div className="flex h-[70px] w-28 items-center justify-end text-right px-2 ">
                        {planPosition.contract_end_date ? (
                            <>
                                {MONTHS[
                                    Number(
                                        planPosition.contract_end_date?.slice(
                                            5,
                                            7
                                        )
                                    ) - 1
                                ] + ' '}
                                {planPosition.contract_end_date?.slice(0, 4)}
                            </>
                        ) : (
                            '-'
                        )}
                    </div>
                    <div className="flex h-[70px] w-44 items-center justify-center text-center">
                        <p className="fourrow">
                            {planPosition.purchase_method_name
                                ? planPosition.purchase_method_name
                                : '-'}
                        </p>
                    </div>
                    <div className="flex h-[70px] w-24 items-center justify-center text-center">
                        {planPosition.type_object_purchase_position
                            ? GWS.get(
                                  String(
                                      planPosition.type_object_purchase_position
                                  )
                              )
                            : '-'}
                    </div>
                    <HoverTooltip
                        tooltipText={`${planPosition.struct_name ? planPosition.struct_name : 'Отсутствует'}`}
                        align="center"
                    >
                        <div className="flex h-[70px] w-24 items-center justify-center text-center">
                            {planPosition.struct_guid !== undefined &&
                            planPosition.struct_guid !== null &&
                            planPosition.struct_guid !== ''
                                ? getNameStruct(planPosition.struct_guid)
                                : '-'}
                        </div>
                    </HoverTooltip>
                    <div className="flex h-[70px] w-20 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                        {planPosition.position_version}
                    </div>
                    <div className="flex h-[70px] w-20 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                        {formattedUpdateDate}
                        <br />
                        {formattedUpdateTime}
                    </div>
                    <div className="flex h-[70px] w-14 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                        <HoverTooltip
                            tooltipText={
                                planPosition.first_name !== null
                                    ? planPosition.last_name +
                                      ' ' +
                                      planPosition.first_name
                                    : 'Отсутствует'
                            }
                            align="left"
                        >
                            <div className="flex h-8 w-8 rounded-full items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#d9dce0] dark:bg-[#333033]">
                                {planPosition.first_name !== null
                                    ? planPosition.last_name?.charAt(0) +
                                      planPosition.first_name?.charAt(0)
                                    : 'О'}
                            </div>
                        </HoverTooltip>
                    </div>
                </div>
            )}
        </>
    )
}

export default PlanPositionsTableRow
